module.exports = __webpack_public_path__ + "static/media/pptx.e8f28ab5.svg";